import React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export function DispatchFilters({
  filterDateFrom,
  setFilterDateFrom,
  filterDateTo,
  setFilterDateTo,
  filterProject,
  setFilterProject,
  filterNave,
  setFilterNave,
  filterLote,
  setFilterLote,
  searchTerm,
  setSearchTerm,
  projects,
  navesForFilter,
  lotesForFilter,
  onClear
}) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-4">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {/* Filtro Fecha Desde */}
          <div className="relative">
            <Label className="absolute -top-2 left-2 bg-white px-1 text-[10px] text-slate-500 z-10">Desde</Label>
            <Input
              type="date"
              value={filterDateFrom}
              onChange={(e) => setFilterDateFrom(e.target.value)}
              className="text-sm"
            />
          </div>
          
          {/* Filtro Fecha Hasta */}
          <div className="relative">
            <Label className="absolute -top-2 left-2 bg-white px-1 text-[10px] text-slate-500 z-10">Hasta</Label>
            <Input
              type="date"
              value={filterDateTo}
              onChange={(e) => setFilterDateTo(e.target.value)}
              className="text-sm"
            />
          </div>
          
          {/* Filtro Proyecto */}
          <Select 
            value={filterProject || "all"} 
            onValueChange={(v) => {
              setFilterProject(v === "all" ? "" : v);
              setFilterNave('');
              setFilterLote('');
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Proyecto" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos los proyectos</SelectItem>
              {(() => {
                // Obtener nombres únicos de proyectos (sin repetir)
                const uniqueProjectNames = [...new Set(projects.map(p => p.name))];
                return uniqueProjectNames.map(name => {
                  const proj = projects.find(p => p.name === name);
                  return (
                    <SelectItem key={name} value={name}>
                      {name} {proj?.animal_type && `(${proj.animal_type === 'pollo' ? 'Pollo' : proj.animal_type === 'gallina' ? 'Gallina' : proj.animal_type === 'cerdo' ? 'Cerdo' : 'Becerro'})`}
                    </SelectItem>
                  );
                });
              })()}
            </SelectContent>
          </Select>
          
          {/* Filtro Nave */}
          <Select 
            value={filterNave || "all"} 
            onValueChange={(v) => {
              setFilterNave(v === "all" ? "" : v);
              setFilterLote('');
            }}
            disabled={!filterProject}
          >
            <SelectTrigger className={!filterProject ? 'opacity-50' : ''}>
              <SelectValue placeholder="Nave" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas las naves</SelectItem>
              {navesForFilter.map(nave => (
                <SelectItem key={nave} value={nave.toString()}>Nave {nave}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          {/* Filtro Lote */}
          <Select 
            value={filterLote || "all"} 
            onValueChange={(v) => setFilterLote(v === "all" ? "" : v)}
            disabled={!filterProject}
          >
            <SelectTrigger className={!filterProject ? 'opacity-50' : ''}>
              <SelectValue placeholder="Lote" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos los lotes</SelectItem>
              {lotesForFilter.map(lote => (
                <SelectItem key={lote} value={lote}>Lote {lote}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          {/* Buscador */}
          <div className="relative col-span-2">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input
              placeholder="Buscar despacho..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
          
          <Button variant="outline" onClick={onClear}>
            Limpiar
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
